<!-- 手机号 -->
<template>
    <el-popover :visible="state.visible" :virtual-ref="triggerRef" placement="bottom" :width="400"
        :show-after="0" :hide-after="0" @before-enter="show">
        <div style="width: 100%;display: flex;">
            <el-date-picker v-model="state.value" type="datetimerange" range-separator="-" :shortcuts="shortcuts"
                start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss" date-format="YYYY-MM-DD" time-format="HH:mm:ss" style="width: 100%"
                @change="handleSearch(2)" />
        </div>
        <div class="btn-box">
            <el-button size="small" @click="handleSearch(3)">关闭</el-button>
            <el-button size="small" @click="handleSearch(1)">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch(2)">筛选</el-button>
        </div>
    </el-popover>
</template>
<script setup>
import { reactive } from 'vue';
const props = defineProps({
    field: {
        type: String,
        default: () => ''
    },
    triggerRef: {
        type: Object,
        default: () => { }
    },
    formValue: {
        type: Object,
        default: () => { }
    }
});
const emit = defineEmits(['handleSearch'])
const state = reactive({
    visible: false,
    value: props.formValue[props.field]
});
const handleSearch = (type) => {
    if (type == 3) {
        state.visible = false;
        return;
    }
    if (type == 1) {
        // 重置
        state.value = '';
    }
    props.formValue[props.field] = state.value;
    state.visible = false;
    emit('handleSearch');
}
const show = () => {
    state.value = props.formValue[props.field];
}
const shortcuts = [
    {
        text: '近一周',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        },
    },
    {
        text: '近一个月',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        },
    },
    {
        text: '近三个月',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
        },
    }, {
        text: '近一年',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12)
            return [start, end]
        },
    },
]
defineExpose(({
    state,
}))
</script>
<style lang="scss" scoped>
.btn-box {
    text-align: right;
    padding-top: 12px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>